import { render, staticRenderFns } from "./BookPanel.vue?vue&type=template&id=787b2426&"
import script from "./BookPanel.vue?vue&type=script&lang=js&"
export * from "./BookPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports